import WhiteLabelInspiration from "../../repository/whiteLabelInspiration"
import { __loco } from '../../../../utils/localization';
import { getPathUrlGenerator } from '../../../../adlevo-vue/utils/getImageUrl';

let totalPage = 0;
let currentPage = 1;
let itemPerPage = 5;
let initalItemPerPage = 5;
let lastResponseData = []

$(document).ready(function () {
    fetchInspiration(currentPage, initalItemPerPage);
    getSeeMoreContentBtn().addEventListener('click', onSeeMoreButtonClick)
})
async function fetchInspiration(currentPage, itemPerPage, append) {
    try {
        let inspirationId = getInspirationId();
        showInspirationListingLoading();
        const inspirationService = new WhiteLabelInspiration();
        const response = await inspirationService.getInspiration(inspirationId, currentPage, itemPerPage);
        totalPage = response.last_page;
        currentPage = response.current_page;

        if (append) {
            lastResponseData = [...lastResponseData, ...response.data];
        } else {
            lastResponseData = response.data;
        }

        if (!lastResponseData.length) {
            const inspirationContainer = document.getElementById('inspiration-container');
            if (!inspirationContainer.classList.contains('d-none')) {
                inspirationContainer.classList.toggle('d-none');
            }
        }
        renderInspirationList(response.data, append);
    }
    catch (e) {
        console.log(e);
    } finally {
        hideInspirationListingLoading();
    }
}

function renderInspirationList(inspirations, append) {

    if (!append) {
        document.querySelector('.inspirationWrapper').innerHTML = '';
    }
    inspirations.forEach((inspiration, index) => {
        document.querySelector('.inspirationWrapper').appendChild(renderInspiration(inspiration, index, append));
    })
}

function renderInspiration(inspiration, index, append) {
    const insElement = document.createElement('div');
    if (!append && index <= 1) {
        insElement.classList.add('col-12', 'col-sm-12', 'col-md-6', 'col-lg-6', 'mt-3', 'discoverCardWrapper');
    } else {
        insElement.classList.add('col-12', 'col-sm-12', 'col-md-4', 'col-lg-4', 'mt-3', 'discoverCardWrapper');
    }
    insElement.innerHTML =
        ' <a href="' + inspiration.id + '-' + convertToSlug(inspiration.title) + '" class="normal-text">' +
        '<div class="discoverCard m-0">' +
        '<img src="' + (inspiration.photos && inspiration.photos.length ? getInspirationCardImgUrl(inspiration.photos[0].path_url) : '') + '" class="disCoverCardImage lazy" alt="' + inspiration.title + '" />' +
        '<div class="discoverColorOverlay"></div>' +
        '<div class="discoverOverlay"></div>' +
        '<div class="discoverCardBody">' +
        ' <div class="subtitle-1 font-weight-medium discoverCardTitle">' + inspiration.title + '</div>' +
        '</div>' +
        '</div>' +
        '</a>';
    return insElement;
}

function convertToSlug(Text) {
    return Text
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
        ;
}

function getInspirationId() {
    const element = document.getElementById('inspiration-content');
    const inspirationId = element.getAttribute('data-inspiration-id');
    return inspirationId;
}

function getInspirationListingLoading() {
    return document.getElementById('inspiration-listing-loading');
}

function getSeeMoreContentBtn() {
    return document.getElementById('see-more-content-btn');
}

function showInspirationListingLoading() {
    const inspirationListingLoaderEl = getInspirationListingLoading();
    if (inspirationListingLoaderEl.classList.contains('d-none')) {
        inspirationListingLoaderEl.classList.toggle('d-none');

        getSeeMoreContentBtn().classList.toggle('d-none');
    }
}

function hideInspirationListingLoading() {
    const inspirationListingLoaderEl = getInspirationListingLoading();
    if (!inspirationListingLoaderEl.classList.contains('d-none')) {
        inspirationListingLoaderEl.classList.toggle('d-none');

        const seeMoreContentBtn = getSeeMoreContentBtn();
        if (currentPage < totalPage) {
            if (seeMoreContentBtn.classList.contains('d-none')) {
                seeMoreContentBtn.classList.toggle('d-none');
            }
        }
    }
}

function onSeeMoreButtonClick(event) {
    event.preventDefault();

    if (!currentPage < totalPage) {
        currentPage += 1;
    }

    fetchInspiration(currentPage, itemPerPage, true);

}

function getInspirationCardImgUrl(url){
    if(url){
        return getPathUrlGenerator(url).setOutputFormat('auto').setHeight(260).setWidth(653)
        .setOtherOptions({
            fit: "crop",
            crop: "edges"
        })
        .build();
    }
    return url;
}